import { TSupport } from '@/features/programs/api/get-supports';
import { getSupportAliasById } from '@/features/programs/helpers/supports';

import { UNDEFINED_SUPPORT_ID } from '../constants';
import { TimeKeepingSupportRegistry } from '../types';

export type SortedSupport = {
  registry: TimeKeepingSupportRegistry;
  alias: string;
};

const collators = new Map<string, Intl.Collator>();

const getCollator = (locale?: string) => {
  const bcp47Locale = locale?.replace('_', '-') ?? '';
  const cached = collators.get(bcp47Locale);
  if (cached) return cached;

  const collator = new Intl.Collator(bcp47Locale || undefined, {
    numeric: true,
    sensitivity: 'base',
  });
  collators.set(bcp47Locale, collator);

  return collator;
};

export const resolveSupportAlias = (
  presenceId: string,
  allSupports: TSupport[],
  undefinedLabel: string
): string => {
  if (presenceId === UNDEFINED_SUPPORT_ID) return undefinedLabel;

  return getSupportAliasById(presenceId, allSupports) ?? presenceId;
};

export const sortSupportsByAlias = (
  supports: TimeKeepingSupportRegistry[],
  allSupports: TSupport[],
  undefinedLabel: string,
  locale?: string
): SortedSupport[] => {
  const collator = getCollator(locale);

  return supports
    .map(registry => ({
      registry,
      alias: resolveSupportAlias(registry.presenceId, allSupports, undefinedLabel),
    }))
    .sort((a, b) => collator.compare(a.alias, b.alias));
};
